import { useState } from 'react';
import SEO from '../components/SEO';
import '../styles/admin.css';

const PRODUCT_NAMES = {
  'BAR_GOLD_0_2G': '0.2g (0.05돈)', 'BAR_GOLD_0_5G': '0.5g (0.13돈)', 'BAR_GOLD_1G': '1g (0.26돈)',
  'BAR_GOLD_1_875G': '1.875g (0.5돈)', 'BAR_GOLD_3_75G': '3.75g (1돈)', 'BAR_GOLD_5G': '5g (1.33돈)',
  'BAR_GOLD_7_5G': '7.5g (2돈)', 'BAR_GOLD_10G': '10g (2.66돈)', 'BAR_GOLD_11_25G': '11.25g (3돈)',
  'BAR_GOLD_18_75G': '18.75g (5돈)', 'BAR_GOLD_37_5G': '37.5g (10돈)', 'BAR_GOLD_50G': '50g (13.33돈)',
  'BAR_GOLD_75G': '75g (20돈)', 'BAR_GOLD_100G': '100g (26.66돈)', 'BAR_GOLD_375G': '375g (100돈)',
  'BAR_GOLD_500G': '500g (133.33돈)', 'BAR_GOLD_1000G': '1000g (266.66돈)',
  'BAR_SILVER_100G': '100g (26.66돈)', 'BAR_SILVER_500G': '500g (133.33돈)', 'BAR_SILVER_1000G': '1000g (266.66돈)',
  'RING_GOLD_0_5DON': '1.875g (0.5돈)', 'RING_GOLD_1DON_TYPE1': '3.75g (1돈 타입1)', 'RING_GOLD_1DON_TYPE2': '3.75g (1돈 타입2)', 'RING_GOLD_1DON_TYPE3': '3.75g (1돈 타입3)',
  'BRACELET_GOLD_1DON': '3.75g (1돈)', 'BRACELET_GOLD_2DON': '7.5g (2돈)', 'BRACELET_GOLD_3DON': '11.25g (3돈)', 'BRACELET_GOLD_5DON': '18.75g (5돈)', 'BRACELET_GOLD_10DON': '37.5g (10돈)',
  'PENDANT_GOLD_KEY_1DON': '3.75g (1돈)', 'PENDANT_GOLD_KEY_2DON': '7.5g (2돈)', 'PENDANT_GOLD_KEY_3DON': '11.25g (3돈)', 'PENDANT_GOLD_KEY_5DON': '18.75g (5돈)', 'PENDANT_GOLD_KEY_10DON': '37.5g (10돈)',
  'PENDANT_GOLD_LUCKYSET_1DON': '3.75g (1돈)', 'PENDANT_GOLD_LUCKYSET_3DON': '11.25g (3돈)', 'PENDANT_GOLD_LUCKYSET_5DON': '18.75g (5돈)', 'PENDANT_GOLD_LUCKYSET_10DON': '37.5g (10돈)'
};

const CATEGORIES = [
  { name: '골드바', prefix: 'BAR_GOLD' },
  { name: '실버바', prefix: 'BAR_SILVER' },
  { name: '금 반지', prefix: 'RING_GOLD' },
  { name: '금 팔찌', prefix: 'BRACELET_GOLD' },
  { name: '금 열쇠', prefix: 'PENDANT_GOLD_KEY' },
  { name: '금 동물', prefix: 'PENDANT_GOLD_LUCKYSET' }
];

function AdminPanel() {
  const [token, setToken] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFetch = async () => {
    setLoading(true);
    setError('');
    
    try {
      // 3개 JSON 파일 동시 호출 (토큰을 헤더에 포함)
      const [res1, res2, res3] = await Promise.all([
        fetch('/admin/data/type1.json', {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch('/admin/data/type2.json', {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch('/admin/data/type3.json', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);
      
      if (!res1.ok || !res2.ok || !res3.ok) {
        throw new Error('잘못된 토큰입니다');
      }
      
      const [data1, data2, data3] = await Promise.all([
        res1.json(),
        res2.json(),
        res3.json()
      ]);
      
      // 데이터 합치기
      setData({
        [data1.name]: data1.prices,
        [data2.name]: data2.prices,
        [data3.name]: data3.prices
      });
    } catch (err) {
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const renderCategory = (category) => {
    const products = Object.keys(PRODUCT_NAMES).filter(k => k.startsWith(category.prefix));
    const companies = Object.keys(data);
    
    return (
      <>
        <tr className="section-divider">
          <td className="section-title">{category.name}</td>
          {companies.map(c => <td key={c} className="section-empty" />)}
        </tr>
        {products.map(productKey => {
          const prices = companies.map(c => data[c][productKey]);
          const minPrice = Math.min(...prices);
          
          return (
            <tr key={productKey}>
              <td className="product-name">{PRODUCT_NAMES[productKey]}</td>
              {companies.map(c => (
                <td key={c} className={data[c][productKey] === minPrice ? 'best' : ''}>
                  {data[c][productKey]?.toLocaleString()}
                </td>
              ))}
            </tr>
          );
        })}
      </>
    );
  };

  return (
    <>
      <SEO 
        title="관리자 - 한국국민금거래소"
        description="한국국민금거래소 관리자 페이지"
        keywords="한국국민금거래소"
        url="https://koreakookmingold.com/admin"
      />

      <div className="admin-panel">
        <section className="admin-panel__hero">
          <div className="admin-panel__hero-content">
            <h1 className="admin-panel__hero-title">관리자</h1>
            <p className="admin-panel__hero-subtitle">
              한국국민금거래소<br />
              관리자 페이지
            </p>
          </div>
        </section>

        <section className="admin-panel__section">
          <div className="admin-panel__container">
            {!data ? (
              <div className="admin-panel__control-card">
                <span className="admin-panel__control-label">액세스 인증</span>
                <div className="admin-panel__auth">
                  <input 
                    type="password"
                    className="admin-panel__input"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    placeholder="액세스 토큰 입력"
                    onKeyPress={(e) => e.key === 'Enter' && handleFetch()}
                  />
                  <button 
                    className="admin-panel__button"
                    onClick={handleFetch}
                    disabled={loading || !token}
                  >
                    {loading ? '로딩 중...' : '확인'}
                  </button>
                </div>
              </div>
            ) : (
              <div className="admin-panel__actions">
                <button className="admin-panel__refresh" onClick={handleFetch}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                  </svg>
                  새로고침
                </button>
              </div>
            )}

            {error && <div className="admin-panel__error">{error}</div>}

            {data && (
              <div className="admin-panel__data">
                <div className="price-table-wrapper">
                  <table className="price-table">
                    <thead>
                      <tr>
                        <th>무게</th>
                        {Object.keys(data).map(company => (
                          <th key={company}>{company}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {CATEGORIES.map(cat => renderCategory(cat))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default AdminPanel;
